module.exports = __webpack_public_path__ + "media/images/category/dummy/accessory03-dfdc46e5f0a713934e1df6076326ba1c.jpg";